import { render, staticRenderFns } from "./MapStatistics.vue?vue&type=template&id=3afad7ba&scoped=true"
import script from "./MapStatistics.vue?vue&type=script&lang=js"
export * from "./MapStatistics.vue?vue&type=script&lang=js"
import style0 from "./MapStatistics.vue?vue&type=style&index=0&id=3afad7ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3afad7ba",
  null
  
)

export default component.exports